"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacing = exports.Spacing = void 0;
var Spacing = /** @class */ (function () {
    function Spacing(px) {
        this.px = px;
    }
    Spacing.fromPixels = function (px) {
        return new Spacing(px + "px");
    };
    Spacing.prototype.toString = function () {
        return this.px;
    };
    Spacing.prototype.getValue = function () {
        return parseFloat(this.px);
    };
    return Spacing;
}());
exports.Spacing = Spacing;
exports.spacing = {
    xxs: Spacing.fromPixels(4),
    xs2: Spacing.fromPixels(4),
    xs: Spacing.fromPixels(8),
    sm: Spacing.fromPixels(12),
    md: Spacing.fromPixels(16),
    lg: Spacing.fromPixels(24),
    xl: Spacing.fromPixels(36),
    xl2: Spacing.fromPixels(48),
    xl3: Spacing.fromPixels(64),
    xl4: Spacing.fromPixels(96),
    xl5: Spacing.fromPixels(128),
};
//# sourceMappingURL=spacing.js.map